import React, { useEffect, useState } from "react";
import RecordCard from "../../global/RecordCard";
import { GooglePlayLogo } from "phosphor-react";
import { Lock, Share2 } from "lucide-react";
import { BonusGraph } from "../../global/BonusGraph";

import { UtilMeter } from "../../tools/UtilMeter";
import { DailyInstallGraph } from "../../tools/DailyInstallGraph";
import { getAnalytics, getBonusSource, getBonusStat, getStats } from "./api";
import toast from "react-hot-toast";

export default function AnalyticsApp() {
  const [summary, setSummary] = useState({});
  const [metrics, setMetrics] = useState([]);
  const [dailyGraph, setDailyGraph] = useState([]);
  const [bonusGraph, setBonusGraph] = useState([]);
  const [days, setDays] = useState(7);
  const [bonusDays, setBonusDays] = useState(7);
  const [bonus, setBonus] = useState(() => {
    return localStorage.getItem("bonusTab") || "DAILYBONUS";
  });
  const [bonusSource, setBonusSource] = useState([]);

  const colorClasses = {
    blue: {
      text: "text-blue-600",
      icon_bg: "bg-blue-600/20",
      progress_bg: "bg-blue-600",
    },
    green: {
      text: "text-green-600",
      icon_bg: "bg-green-600/20",
      progress_bg: "bg-green-600",
    },
    red: {
      text: "text-red-600",
      icon_bg: "bg-red-600/20",
      progress_bg: "bg-red-600",
    },
    yellow: {
      text: "text-yellow-500",
      icon_bg: "bg-yellow-500/20",
      progress_bg: "bg-yellow-500",
    },
    purple: {
      text: "text-purple-600",
      icon_bg: "bg-purple-600/20",
      progress_bg: "bg-purple-600",
    },
  };
  const getAnalyticsData = async () => {
    try {
      const res = await getAnalytics();
      if (res.status === 200) {
        const data = res?.data;
        setSummary(data?.summary);
        setMetrics(data?.metrics || []);
      }
    } catch (err) {
      console.error("failed to get analytics :", err);
    }
  };
  const getStatsData = async () => {
    try {
      const res = await getStats(days);
      if (res.status === 200) {
        const data = res?.data;
        setDailyGraph(data?.graph || []);
      }
    } catch (err) {
      console.error("failed to get analytics :", err);
    }
  };
  const getBonusData = async () => {
    try {
      const res = await getBonusStat(bonusDays, bonus);
      if (res.status === 200) {
        const data = res?.data;
        setBonusGraph(data?.data || []);
      }
    } catch (err) {
      console.error("failed to get analytics :", err);
    }
  };

  const getBonusSourceData = async () => {
    try {
      const res = await getBonusSource();
      if (res.status === 200) {
        const data = res?.data;
        setBonusSource(data || []);
      }
    } catch (err) {
      console.error("failed to get analytics :", err);
    }
  };
  useEffect(() => {
    getAnalyticsData();
    getBonusSourceData();
  }, []);

  useEffect(() => {
    getBonusData();
  }, [bonusDays, bonus]);

  useEffect(() => {
    getStatsData();
  }, [days]);

  return (
    <div className="space-y-4 flex flex-col w-full">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {/* User Summary Cards */}
        <RecordCard
          title1={"Users"}
          value1={summary.total_installs}
          title2={"Registration"}
          value2={summary.total_registrations}
          color={colorClasses.green}
          icon={GooglePlayLogo}
        />
        {/* Referral Summary Cards */}
        <RecordCard
          title1={"Referrals"}
          value1={summary.referral_installs}
          title2={"Organic"}
          value2={summary.organic_installs}
          color={colorClasses.blue}
          icon={Share2}
        />
        {/* Blocked Summary Cards */}
        <RecordCard
          title1={"Blocked"}
          value1={summary.blocked_users}
          title2={"Signouts"}
          value2={summary.total_signouts}
          color={colorClasses.red}
          icon={Lock}
        />
        {/* Today Summary Cards */}
        <RecordCard
          title1={"Today"}
          value1={metrics[0]?.installs}
          title2={"Registrations"}
          value2={metrics[0]?.registrations}
          color={colorClasses.green}
          icon={GooglePlayLogo}
        />
        {/* Last 7 Days */}
        <RecordCard
          title1={"Last 7 Days"}
          value1={metrics[1]?.installs}
          title2={"Registrations"}
          value2={metrics[1]?.registrations}
          color={colorClasses.green}
          icon={GooglePlayLogo}
        />
        {/* Last 30 Days */}
        <RecordCard
          title1={"Last 30 Days"}
          value1={metrics[2]?.installs}
          title2={"Registrations"}
          value2={metrics[2]?.registrations}
          color={colorClasses.green}
          icon={GooglePlayLogo}
        />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 items-start justify-between gap-4">
        <BonusGraph
          name={bonus}
          days={bonusDays}
          onTabChange={(days) => setBonusDays(days)}
          className="col-span-2"
          data={bonusGraph}
          x
          bonusList={bonusSource}
          onBonusTabChange={(tab) => {
            if (tab !== bonus) {
              setBonus(tab);
            }
          }}
        />

        <UtilMeter
          title={"Monthly Target"}
          subtitle={"Last 30 days utilization"}
          credit={23}
          refund={33}
          spent={99}
          utitPer={20}
          className="col-span-2 lg:col-span-1 w-full"
        />
      </div>

      <DailyInstallGraph
        title={"Daily Installs & Registered Users"}
        graphData={dailyGraph}
        days={days}
        onTabChange={(days) => setDays(days)}
      />
    </div>
  );
}
